import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { Doughnut, Bar } from "react-chartjs-2";
import { bucketTopN } from "./_shared/bucketTopN";
import CustomLegend from "./_shared/CustomLegend";
import ChartState from "./_shared/ChartState";
import { donutOptions, barOptions } from "./_shared/chartTheme";

const DiamondReportsSizeComp = ({ data, loading }) => {
  const { t } = useTranslation();
  const [chartType, setChartType] = useState("doughnut");

  const { chartData, colors } = bucketTopN(data || [], {
    labelKey: "Size",
    valueKey: "CNT",
    chartLabel: "Size",
    othersLabel: t("Others"),
  });
  const rows = chartData.slice(1);

  const chartJsData = {
    labels: rows.map((row) => row[0]),
    datasets: [
      {
        data: rows.map((row) => row[1]),
        backgroundColor: colors,
        borderColor: "#fff",
        borderWidth: chartType === "doughnut" ? 2 : 0,
        borderRadius: chartType === "bar" ? 4 : 0,
      },
    ],
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <div className="edr-panel-head">
          <label>
            <b> {t("Diamond Size Searches")} </b>
          </label>
          <div className="edr-seg">
            <button
              className={chartType === "doughnut" ? "edr-on" : ""}
              onClick={() => setChartType("doughnut")}
            >
              {t("Donut")}
            </button>
            <button
              className={chartType === "bar" ? "edr-on" : ""}
              onClick={() => setChartType("bar")}
            >
              {t("Bar")}
            </button>
          </div>
        </div>
        <div
          className="chart__section"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Spin spinning={loading} size="large">
            {rows.length > 0 ? (
              <>
                {chartType === "doughnut" && (
                  <CustomLegend chartData={chartData} colorData={colors} />
                )}
                <div className="edr-chartwrap edr-tall">
                  {chartType === "doughnut" ? (
                    <Doughnut data={chartJsData} options={donutOptions} />
                  ) : (
                    <Bar data={chartJsData} options={barOptions(true)} />
                  )}
                </div>
              </>
            ) : (
              <ChartState loading={loading} />
            )}
          </Spin>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsSizeComp;
